import { UrlConstants } from "../url.constants";
export class ApiConditionConstants {
    static URL = UrlConstants.API_V2 + "Condition";
}
